import React from 'react';

import ImageGallery from '../../common/ImageGallery';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const ImagesBlock = (props) => {
  const { t } = useAutoTranslation();
  return (
    <div className="col-lg-6">
      <div className="card-box">
        <div className="row">
          <div className="col-12">
            <h4 className="header-title">{t('Изображения')}</h4>
          </div>
        </div>

        <ImageGallery {...props} />
      </div>
    </div>
  );
};

export default ImagesBlock;
